import { render, staticRenderFns } from "./DashboardShifts.vue?vue&type=template&id=d7a1fe50&"
import script from "./DashboardShifts.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardShifts.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports